// TODO: there's an issue with the list of bibles being provided to this component are `undefined`
// the filter BibleList's render function is a temporary work around for this issue. As we moved to typescript
// we need to make sure that only data that is defined gets to this component and that this filter call is removed

import React from "react";
import styled from "styled-components";

import { BibleListItem } from "../../ListItems";
import { StateBible } from "components/Bible/BibleContainer";

const noOp = () => {};

export const List = styled.div`
  padding: 4px 0;
`;

interface BibleListProps {
  bibles: StateBible[];
  currentBibleId: string;
  onBibleClick: (bibleId: string) => void;
  siteBibleIds: string[];
}

export const BibleList = ({
  bibles = [],
  currentBibleId = "",
  onBibleClick = noOp,
  siteBibleIds
}: BibleListProps) => (
  <List>
    {siteBibleIds
      .map(id => bibles.find(bible => bible.id === id))
      .map((bible: StateBible | undefined) =>
        bible ? (
          <BibleListItem
            bible={bible as StateBible}
            key={bible.id}
            active={currentBibleId === bible.id}
            onClick={() => onBibleClick(bible.id)}
          />
        ) : null
      )}
  </List>
);
